import { useQuery } from '@tanstack/react-query';
import {
  ACTIVE_SERVICES_QUERY_KEY,
  BOOKABLE_SERVICES_QUERY_KEY,
  listActiveServices,
  listBookableServices,
} from '@/services/firestore/services';
import { getSalonLocation } from '@/services/firestore/locations';

export function useBookableServices() {
  return useQuery({
    queryKey: BOOKABLE_SERVICES_QUERY_KEY,
    queryFn: listBookableServices,
    staleTime: 10 * 60 * 1000,
  });
}

export function useServicesCatalog() {
  return useQuery({
    queryKey: ACTIVE_SERVICES_QUERY_KEY,
    queryFn: listActiveServices,
    staleTime: 10 * 60 * 1000,
  });
}

export function useSalonLocation() {
  return useQuery({
    queryKey: ['salonLocation'],
    queryFn: getSalonLocation,
    staleTime: 10 * 60 * 1000,
  });
}
